<template>
    <div class="stage">
        <div class="questions-wrapper">
            <div class="questions-block">
                <div class="question-block">
                    <div class="question">
                        Чи отримував пацієнт попередню терапію до візиту до Вас?
                    </div>
                    <div class="answers">
                        <div class="answer" :class="himResult === '2 курси ABVD' ? 'active' : ''" @click="himResult = '2 курси ABVD'">
                            <input type="radio" id="1" name="himResult" v-model="himResult" value="2 курси ABVD" required>
                            <label for="1"><strong>Так, 2 курси ABVD</strong></label>
                        </div>
                        <div class="answer" :class="himResult === '2 курси escBEACOPP' ? 'active' : ''" @click="himResult = '2 курси escBEACOPP'" v-if="getIsSimplePatient">
                            <input type="radio" id="2" name="himResult" v-model="himResult" value="2 курси escBEACOPP" required>
                            <label for="2"><strong>Так, 2 курси escBEACOPP</strong></label>
                        </div>
                        <div class="answer" :class="himResult === 'Не отримував хіміотерапію' ? 'active' : ''" @click="himResult = 'Не отримував хіміотерапію'">
                            <input type="radio" id="3" name="himResult" v-model="himResult" value="Не отримував хіміотерапію" required>
                            <label for="3"><strong>Не отримував хіміотерапію</strong></label>
                        </div>
                    </div>
                </div>

                <error-block />
            </div>
        </div>
    </div>
</template>

<script>
import ErrorBlock from '../../../../../components/Doctor/ErrorBlock';
import { mapMutations, mapGetters } from 'vuex';

export default {
    components : {
        'error-block' : ErrorBlock
    },
    data : () => ({
        himResult : ''
    }),
    computed : {
        ...mapGetters([
            'getHimResult',
            'getIsSimplePatient'
        ])
    },
    methods : {
        ...mapMutations([
            'setHimResult',
        ])
    },
    created(){
        this.himResult = this.getHimResult;
    },
    watch : {
        himResult : function(value){
            this.setHimResult(value);
        }
    }
}
</script>

<style lang="scss" scoped>
.stage{
    .questions-wrapper{
        width: 405px;
        height: auto;

        .questions-block{
            padding: 20px 40px;

            .question-block{
                .question{
                    font-size: 26px;
                }

                .answers{
                    padding-bottom: 0;

                    .answer{
                        width: 100%;

                        label{
                            font-size: 12px;
                            font-weight: 300;

                            strong{
                                padding-right: 3px;
                                font-size: 14px;
                            }
                        }
                    }

                    .answer:nth-child(2n){
                        margin-left: 0;
                    }
                }
            }           
        }        
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .stage{
        .questions-wrapper{
            width: 40vw;
            height: auto;

            .questions-block{
                padding: 3.125vw 3.333vw;

                .question-block{
                    .question{
                        font-size: 1.667vw;
                    }

                    .answers{
                        .answer{
                            width: 100%;

                            margin-right: 0;

                            label{
                                font-size: 0.95vw;

                                strong{
                                    font-size: 1.042vw;
                                }
                            }
                        }
                    }
                }           
            }
        }
    }
}

@media (max-width: 599px){
    .stage{
        .questions-wrapper{
            width: 100%;

            .questions-block{
                padding: 5.556vw 5.278vw 6.667vw 5.556vw;

                .question-block{
                    .question{
                        font-size: 5.556vw;
                    }

                    .answers{
                        .answer{
                            label{
                                font-size: 3vw;
                            }
                        }
                    }

                }
            }
        }
    }
}
</style>